angular.module('rjmNg.constants')
.constant("rjqlStringConstants"
  RJQL_UNBOUND: ':unbound'
  RJQL_TIME: ':time'
  RJQL_PERIODDIFF: ':perioddiff'
  RJQL_UNBOUND_NAME: 'None'
)
.constant("reportQueryType"
  RJQL: 'rjql'
  SQL: 'sql'
)
.constant("queryStatus"
  SUCCESS: 0
  WARNING: 1
  ERROR: 2
)
